import React from 'react';

const MyIcon = ({ lineColor = '#0995ED', bgColor = '#F0F0F0' }) => {
  const strokeWidth = 1.5;
  const cornerRadius = 4;
  const size = 30;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x={strokeWidth / 2}
        y={strokeWidth / 2}
        width={size - strokeWidth}
        height={size - strokeWidth}
        rx={cornerRadius}
        ry={cornerRadius}
        fill={bgColor}
        stroke={lineColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M12.091 9.659C13.2195 10.7864 13.2195 12.2136 12.091 13.341C10.9626 14.4684 9.53544 14.4684 8.407 13.341C7.27853 12.2136 7.27853 10.7864 8.407 9.659C9.53544 8.53157 10.9626 8.53157 12.091 9.659"
        stroke={lineColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 11.25H12.75"
        stroke={lineColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.091 16.659C22.2195 17.7864 22.2195 19.2136 21.091 20.341C19.9626 21.4684 18.5354 21.4684 17.407 20.341C16.2785 19.2136 16.2785 17.7864 17.407 16.659C18.5354 15.5316 19.9626 15.5316 21.091 16.659"
        stroke={lineColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 18.75H17.25"
        stroke={lineColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MyIcon;
